import React, { useEffect, useState } from "react"

import FeatherIcon from "../feather-icon"
import * as styles from "./index.module.scss"

interface Props {
  content: React.ReactNode
  contentStyles?: React.CSSProperties
  trigger?: React.ReactNode
  className?: string
  show?: boolean
  onMouseOver?: boolean
  as?: "div" | "span"
}

function Tooltip({
  className,
  content,
  contentStyles,
  trigger,
  show,
  onMouseOver,
  as = "div",
  ...otherProps
}: Props) {
  const [showTooltip, setShowTooltip] = useState(show)

  useEffect(() => {
    setShowTooltip(!!show)
  }, [show])

  const Element = as

  return (
    <Element className={`${styles.container} ${className}`} {...otherProps}>
      {trigger ? (
        <span
          onMouseEnter={onMouseOver ? () => setShowTooltip(true) : undefined}
          onMouseLeave={onMouseOver ? () => setShowTooltip(false) : undefined}
        >
          {trigger}
        </span>
      ) : (
        <Element
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          <FeatherIcon type="help-circle" className={styles.icon} />
        </Element>
      )}
      {showTooltip && (
        <div className={styles.tooltip} style={{ ...contentStyles }}>
          <div className={styles.text}>{content}</div>
        </div>
      )}
    </Element>
  )
}

Tooltip.defaultProps = {
  trigger: undefined,
  contentStyles: {},
  className: "",
  show: false,
  onMouseOver: true,
  as: "div",
}

export default Tooltip
